import React, { Component, Fragment } from 'react'
import { FormLabel, RadioGroup, FormControlLabel, Radio, Grid, Box, Typography } from '@material-ui/core';
import ApplicationValue from '../model/application-value';
import { Alert, AlertTitle } from '@material-ui/lab';

interface IApkProperties {
    disabled: boolean | undefined;
    onDataChange: any;
    onValidation: any;
    data: ApplicationValue[];
    renderButtons: any;
    nextClick: any;
    prevClick: any;
}


export class ApkForm extends Component<IApkProperties, any> {
    constructor(props: IApkProperties) {
        super(props);

        var apk: any = {};
        props.data.forEach((element) => {
            Object.assign(apk, { [element.key]: element });
        });

        if (!apk.apk_uprawy)
            apk.apk_uprawy = new ApplicationValue('apk_uprawy', '', null);
        if (!apk.apk_gospodarstwo_rolne)
            apk.apk_gospodarstwo_rolne = new ApplicationValue('apk_gospodarstwo_rolne', '', null);
        if (!apk.apk_budynki)
            apk.apk_budynki = new ApplicationValue('apk_budynki', '', null);
        if (!apk.apk_zwierzeta)
            apk.apk_zwierzeta = new ApplicationValue('apk_zwierzeta', '', null);
        if (!apk.apk_mienie_ruchome)
            apk.apk_mienie_ruchome = new ApplicationValue('apk_mienie_ruchome', '', null);
        if (!apk.apk_nnw_czlonkow_gospodarstwa)
            apk.apk_nnw_czlonkow_gospodarstwa = new ApplicationValue('apk_nnw_czlonkow_gospodarstwa', '', null);

        this.state = {
            form: apk,
            errors: []
        };
    }
    
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleChange = (event: any) => {
        let av: ApplicationValue;
        if (this.state.form[event.target.name])
            av = this.state.form[event.target.name];
        else {
            av = new ApplicationValue(event.target.name, '', null);
        }
        av.value = event.target.value;
        av.selectedIndex = av.value === 'true' ? 1 : 0;

        this.setState({
            form: {
                ...this.state.form,
                [event.target.name]: av
            }
        }, () => {
            // let result = this.validateForm();
            // this.props.onDataChange(this.getData(), result);
        });

    }

    validateForm = (): boolean => {
        const state = this.state.form;

        var result = Object.keys(state).filter((key) => {
            return state[key].value === ""
        });

        this.setState({ errors: result });

        return result.length === 0;
    }

    getData = (): ApplicationValue[] => {
        let apk: ApplicationValue[] = [];
        for (let [, value] of Object.entries(this.state.form)) {
            apk.push(value as ApplicationValue);
        }
        return apk;
    }

    next = () => {
        let result = this.validateForm();
        if (result) {
            this.props.onDataChange(this.getData(), result);
            this.props.nextClick();
        } else {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return (
            <Fragment>
                <Box marginBottom={3}>
                    <Typography variant="h5" align="center" gutterBottom={true}>Analiza potrzeb klienta</Typography>
                </Box>
                {
                    this.state.errors.length > 0 ?
                    <>
                        <Alert severity="error">
                            <AlertTitle>Uwaga</AlertTitle>
                            <p>Pola zaznaczone na czerwono są obowiązkowe. Zaznacz je, aby przejść dalej.</p>
                        </Alert>
                        <Typography variant="h5" gutterBottom={true}>&nbsp;</Typography>
                    </>
                    : null
                        
                }                
                <Grid container >
                    <Grid item xs={12} sm={9}>
                        <FormLabel error={this.state.errors.includes("apk_uprawy")}>
                            Czy jesteś producentem rolnym i masz potrzebę oraz prawo obowiązkowego ubezpieczenia upraw z dopłatą z budżetu państwa?
                        </FormLabel>
                    </Grid>
                    <Grid className="apkRow" item xs={12} sm={3}>
                        <RadioGroup className="radio" row name="apk_uprawy" value={this.state.form.apk_uprawy.value} onChange={this.handleChange}>
                            <FormControlLabel value="false" control={<Radio disabled={this.props.disabled} />} label="Nie" />
                            <FormControlLabel value="true" control={<Radio disabled={this.props.disabled} />} label="Tak" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={9}>
                        <FormLabel error={this.state.errors.includes("apk_gospodarstwo_rolne")}>
                            Czy masz potrzebę zawarcia obowiązkowego ubezpieczenia OC rolnika z tytułu posiadania gospodarstwa rolnego?
                        </FormLabel>
                    </Grid>
                    <Grid className="apkRow" item xs={12} sm={3}>
                        <RadioGroup className="radio" row name="apk_gospodarstwo_rolne" value={this.state.form.apk_gospodarstwo_rolne?.value} onChange={this.handleChange}>
                            <FormControlLabel value="false" control={<Radio disabled={this.props.disabled} />} label="Nie" />
                            <FormControlLabel value="true" control={<Radio disabled={this.props.disabled} />} label="Tak" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={9}>
                        <FormLabel error={this.state.errors.includes("apk_budynki")}>
                            Czy masz potrzebę zawarcia obowiązkowego ubezpieczenie budynków wchodzących w skład gospodarstwa rolnego?
                        </FormLabel>
                    </Grid>
                    <Grid className="apkRow" item xs={12} sm={3}>
                        <RadioGroup className="radio" row name="apk_budynki" value={this.state.form.apk_budynki?.value} onChange={this.handleChange}>
                            <FormControlLabel value="false" control={<Radio disabled={this.props.disabled} />} label="Nie" />
                            <FormControlLabel value="true" control={<Radio disabled={this.props.disabled} />} label="Tak" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={9}>
                        <FormLabel error={this.state.errors.includes("apk_zwierzeta")}>
                            Czy masz potrzebę ubezpieczenia zwierząt gospodarskich?
                        </FormLabel>
                    </Grid>
                    <Grid className="apkRow" item xs={12} sm={3}>
                        <RadioGroup className="radio" row name="apk_zwierzeta" value={this.state.form.apk_zwierzeta?.value} onChange={this.handleChange}>
                            <FormControlLabel value="false" control={<Radio disabled={this.props.disabled} />} label="Nie" />
                            <FormControlLabel value="true" control={<Radio disabled={this.props.disabled} />} label="Tak" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={9}>
                        <FormLabel error={this.state.errors.includes("apk_mienie_ruchome")}>
                            Czy masz potrzebę ubezpieczenia mienia ruchomego (maszyny, urządzenia, płody rolne) ?
                        </FormLabel>
                    </Grid>
                    <Grid className="apkRow" item xs={12} sm={3}>
                        <RadioGroup className="radio" row name="apk_mienie_ruchome" value={this.state.form.apk_mienie_ruchome?.value} onChange={this.handleChange}>
                            <FormControlLabel value="false" control={<Radio disabled={this.props.disabled} />} label="Nie" />
                            <FormControlLabel value="true" control={<Radio disabled={this.props.disabled} />} label="Tak" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={9}>
                        <FormLabel error={this.state.errors.includes("apk_nnw_czlonkow_gospodarstwa")}>
                            Czy masz potrzebę ubezpieczenia następstw nieszczęśliwych wypadków członków gospodarstwa?
                        </FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <RadioGroup className="radio" row name="apk_nnw_czlonkow_gospodarstwa" value={this.state.form.apk_nnw_czlonkow_gospodarstwa?.value} onChange={this.handleChange}>
                            <FormControlLabel value="false" control={<Radio disabled={this.props.disabled} />} label="Nie" />
                            <FormControlLabel value="true" control={<Radio disabled={this.props.disabled} />} label="Tak" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                {this.props.renderButtons({ caption: 'Dalej', click: this.next })}
            </Fragment>
        )
    }
}
